import { apiDelete, apiGet, apiPost, apiPut } from './api-service';
import { getUserDetails } from './session-service';

export async function getAllVehicleChecklist() {
    try {
        const response = await apiGet('core', `vehicle-checklist`);
        return response;
    } catch (e) { }
}

export async function getVehicleChecklist(id?: string) {
    try {
        const response = await apiGet('core', `vehicle-checklist/${id}`);
        return response.content;
    } catch (e) {
        return {};
    }
}


export async function addVehicleChecklist(newDetails: any) {
    try {
        const response = await apiPost('core', `vehicle-checklist`, newDetails);
        return response;
    } catch (e) { }
}

export async function updateVehicleChecklist(newDetails: any, id?: string) {
    try {
        if (!id) {
            id = getUserDetails().client_id;
        }
        const response = await apiPut('core', `vehicle-checklist/${id}`, newDetails);

        return response;
    } catch (e) { }
}

export async function removeVehicleChecklist(id: any) {
    try {

        return await apiDelete('core', `vehicle-checklist/${id}`);
    } catch (e) { }
}